import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { XhrHttpHandler } from "@aws-sdk/xhr-http-handler";
import { v4 as uuidv4 } from "uuid";

export function initS3Client() {
  return new S3Client({
    requestHandler: new XhrHttpHandler({}),
    region: process.env.VUE_APP_S3_REGION,
    credentials: {
      accessKeyId: process.env.VUE_APP_S3_ACCESS_KEY_ID,
      secretAccessKey: process.env.VUE_APP_S3_SECRET_ACCESS_KEY,
    },
  });
}

export async function uploadFileToS3(file, client) {
  try {
    if (!client) throw new Error("S3 client is not initialized");
    const params = {
      Bucket: process.env.VUE_APP_S3_BUCKET_NAME,
      Key: uuidv4(),
      Body: file,
    };
    await client.send(new PutObjectCommand(params));
    // console.log(`https://${params.Bucket}.s3.amazonaws.com/${params.Key}`);
    return params.Key;
  } catch (error) {
    alert(error.message);
    return null;
  }
}

export async function uploadWithTracker(file, key, client, cb) {
  const upload = new Upload({
    client,
    params: {
      Bucket: process.env.VUE_APP_S3_BUCKET_NAME,
      Key: key,
      Body: file,
    },
  });
  upload.on("httpUploadProgress", (progress) => {
    cb(progress.loaded, progress.total);
  });
  await upload.done();
}

export function isS3URL(url) {
  const bucket = process.env.VUE_APP_S3_BUCKET_NAME;
  const region = process.env.VUE_APP_S3_REGION;
  const baseUrl = `https://${bucket}.s3.${region}.amazonaws.com`;
  return url.startsWith(baseUrl);
}

export function getS3URL(path) {
  const bucket = process.env.VUE_APP_S3_BUCKET_NAME;
  const region = process.env.VUE_APP_S3_REGION;
  const baseUrl = `https://${bucket}.s3.${region}.amazonaws.com`;
  return new URL(path, baseUrl).toString();
}

export function getS3Path(url) {
  const bucket = process.env.VUE_APP_S3_BUCKET_NAME;
  const region = process.env.VUE_APP_S3_REGION;
  const baseUrl = `https://${bucket}.s3.${region}.amazonaws.com`;
  return url.replace(baseUrl, "");
}
